import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
class SystemCompanies extends Component {

  standardRow = (systemCompany) => {
    return (
      <Row className="adminRow pointer" onClick={() => this.props.onEdit(systemCompany.CompanySettingsID)}>
        <Col md={2} className="text-left">
          <FontAwesomeIcon icon={(systemCompany.CompanyActive) ? faCircle : faCircleOutline} className={"mr-3 " + ((systemCompany.CompanyActive) ? 'iconActive' : 'iconInactive')} />
          {systemCompany.CompanyName}
        </Col>
        <Col md={2} className="text-left">{systemCompany.CompanyDisplayName}</Col>
        <Col md={2} className="text-left">{systemCompany.CompanyPortalDatabase}</Col>
        <Col md={3} className="text-left">{systemCompany.CompanyUseSECData ? 'Uses SEC Data' : ''}</Col>
        <Col md={3} className='text-left'>
          {systemCompany.CompanyLogo &&
            <img
              src={`data:image/png;base64,${systemCompany.CompanyLogo}`}
              alt="Company Logo"
              style={{ maxHeight: '50px' }}
            />}
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (<Row className="py-4 text-left align-items-bottom">
      <Col>
        <Form inline>
          <FormGroup className="pr-2">
            <Input
              placeholder="Company Name"
              type="text"
              name="companyName"
              value={this.props.newSystemCompany.CompanyName}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Company Display Name"
              type="text"
              name="companyDisplayName"
              value={this.props.newSystemCompany.CompanyDisplayName}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Company Portal Database"
              type="text"
              name="companyPortalDatabase"
              value={this.props.newSystemCompany.CompanyPortalDatabase}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          {/* <FormGroup className="px-2">
            <Input
              placeholder="Company Database"
              type="text"
              name="companyDatabase"
              value={this.props.newSystemCompany.CompanyDatabase}
              onChange={e => this.props.onChange(e)} />
          </FormGroup> */}
          <FormGroup className="px-2">
            <Label>
              Logo
              <Input
                type="file"
                accept=".png,.jpg,.jpeg,.gif"
                name="companyLogo"
                onChange={e => this.props.onChange(e)}
              />
            </Label>
          </FormGroup>
          <FormGroup className="px-2">
            <Label>
              <Input
                type="checkbox"
                name="companyUseSECData"
                checked={this.props.newSystemCompany.CompanyUseSECData}
                onChange={e => this.props.onChange(e)} />
              Use SEC Data
            </Label>
          </FormGroup>
          <FormGroup className="px-2">
            <Label>
              <Input
                type="checkbox"
                name="companyActive"
                checked={this.props.newSystemCompany.CompanyActive}
                onChange={e => this.props.onChange(e)} />
              Active
            </Label>
          </FormGroup>
        </Form>
      </Col>
      <Col md={3} className="text-right">
        <Button disabled={this.props.newSystemCompany.CompanyName === '' || this.props.isAdding} color="primary" onClick={this.props.handleAdd}>{this.props.isAdding ? 'Please Wait...' : 'Add Company'}</Button>
      </Col>
    </Row>
    )
  }

  editRow = (systemCompany) => {
    return (<>
      <Row key={"edit" + systemCompany.CompanySettingsID} className="adminRow">
        <Col className="text-left col-md-10">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="Company Name"
                type="text"
                name="companyName"
                disabled={true}
                value={this.props.editSystemCompany.companyName}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Company Display Name"
                type="text"
                name="companyDisplayName"
                value={this.props.editSystemCompany.companyDisplayName}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Company Portal Database"
                type="text"
                name="companyPortalDatabase"
                value={this.props.editSystemCompany.companyPortalDatabase}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            {/* <FormGroup className="px-2">
              <Input
                placeholder="Company Database"
                type="text"
                name="companyDatabase"
                value={this.props.editSystemCompany.companyDatabase}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup> */}
            <FormGroup className="px-2">
              <Label>
                Logo
                <Input
                  type="file"
                  accept=".png,.jpg,.jpeg,.gif"
                  name="companyLogo"
                  onChange={e => this.props.onChange(e, 'edit')}
                />
              </Label>
            </FormGroup>
            <FormGroup className="px-2">
              <Label>
                <Input
                  type="checkbox"
                  name="companyUseSECData"
                  checked={this.props.editSystemCompany.companyUseSECData}
                  onChange={e => this.props.onChange(e, 'edit')} />
                Use SEC Data
              </Label>
            </FormGroup>
            <FormGroup className="px-2">
              <Label>
                <Input
                  type="checkbox"
                  name="companyActive"
                  checked={this.props.editSystemCompany.companyActive}
                  onChange={e => this.props.onChange(e, 'edit')} />
                Active
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col className="text-right col-md-2">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Company">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          {/* <ConfirmButton className="mx-1" color="danger" onClick={()=>this.props.handleDelete(this.props.editSystemCompany.companySettingsID)} title="Delete Company">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton> */}
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
      </Row>
    </>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.systemCompanies.map(systemCompany => (
          <Fragment key={systemCompany.CompanySettingsID}>{this.props.editSystemCompany.companySettingsID === systemCompany.CompanySettingsID ?
            this.editRow(systemCompany) : this.standardRow(systemCompany)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );

  }
}

export default SystemCompanies;
